<template>
  <div>
    <div class="row pb-3">
      <component
        v-for="(field, index) in schema"
        :key="index"
        :is="field.fieldType"
        :value="formData[field.fieldName]"
        @input="updateForm(field.fieldName, $event)"
        v-bind="field"
      ></component>
    </div>
  </div>
</template>

<script>
import NumberInput from "./NumberInput";
import Dropdown from "./SelectList";
import Textbox from "./TextInput";
import DatePicker from "./TextInput";
export default {
  name: "FormGenerator",
  components: { NumberInput, Dropdown, Textbox, DatePicker },
  props: ["schema", "value"],
  data() {
    return {
      formData: this.value || {}
    };
  },
  methods: {
    updateForm(fieldName, Value) {
      this.$set(this.formData, fieldName, Value);
      this.$emit("input", this.formData);
    }
  },
  mounted() {
    // console.log("schema", this.schema);
  }
};
</script>
